import { useRef } from "react";
import cn from "classnames";
import { translations } from "i18n";
import Lottie from "lottie-react";

import styles from "./style.module.scss";

import {
  getRangeMinArray,
  getIntensityText,
} from "containers/WidgetPage/TemplateUtils";
import matchAnimations from "../common/utils/spotMatchAnimationsHelper";

import imgLogo from "./img/logo.png";
import imgClock from "./img/clock.png";
import imgCoins from "./img/coins.png";
import imgVibration from "./img/vibration.png";

const render = (
  preset,
  tips,
  isPreview,
  widgetStep,
  templateBackground,
  templateBackgroundInner
) => {
  const animationRef = useRef();
  const rangeMinArray = getRangeMinArray(preset);

  return (
    <>
      {(isPreview || widgetStep === 0) && (
        <div className={cn(styles.settingsContainer, templateBackground)}>
          <img className={styles.logo} src={imgLogo} alt="" />
          <div className={cn(styles.innerContainer, templateBackgroundInner)}>
            <div className={styles.tipSettingRowsHeader}>
              <div className={styles.itemContainer}>
                <img className={styles.imgCoins} src={imgCoins} alt="" />
                <div className={styles.tipSettingRowsHeaderText}>
                  {translations("SpotOBStemplate.Tokens")}
                </div>
              </div>
              <div className={styles.itemContainer}>
                <img className={styles.imgRound} src={imgClock} alt="" />
                <div className={styles.tipSettingRowsHeaderText}>
                  {translations("SpotOBStemplate.Time")}
                </div>
              </div>
              <div
                className={cn(
                  styles.itemContainer,
                  styles.itemContainerPaddingLeft
                )}
              >
                <img className={styles.imgRound} src={imgVibration} alt="" />
                <div className={styles.tipSettingRowsHeaderText}>
                  {translations("SpotOBStemplate.Vibration")}
                </div>
              </div>
            </div>
            {preset.levels.map((level, index) => {
              if (!+level.intensity) {
                return null;
              }
              return (
                <div
                  className={cn(
                    styles.rowContainer,
                    isPreview && styles.rowContainerWithoutOuterContainer
                  )}
                  key={index}
                >
                  <div className={styles.itemContainer}>
                    <div className={styles.priceRow}>
                      {rangeMinArray[index]} - {level.rangeMax}
                    </div>
                  </div>
                  <div className={styles.itemContainer}>
                    <div className={styles.durationRow}>{level.duration}s</div>
                  </div>
                  <div className={styles.itemContainer}>
                    <div className={styles.intensityColor}>
                      {getIntensityText(level.intensity)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {widgetStep === 1 && !isPreview && (
        <div
          className={cn(
            styles.settingsContainer,
            styles.animationContainer,
            templateBackground
          )}
        >
          <div className={styles.senderTipped}>
            {translations("SpotOBStemplate.ThanksYouSender", {
              sender: tips[tips.length - 1]?.sender,
            })}
          </div>
          <Lottie
            lottieRef={animationRef}
            animationData={matchAnimations(tips)}
            autoplay={false}
            loop={false}
            className={styles.animation}
            onDOMLoaded={() => {
              animationRef.current.setSpeed(
                2 / tips[tips.length - 1]?.duration
              );
              animationRef.current.play();
            }}
          />
        </div>
      )}
    </>
  );
};

const createTemplate = (backgroundStyle, innerBackgroundStyle) => {
  return ({ preset, tips, isPreview, widgetStep }) => (
    <div>
      {isPreview ? (
        render(
          preset,
          tips,
          isPreview,
          widgetStep,
          backgroundStyle,
          innerBackgroundStyle
        )
      ) : (
        <div className={styles.outerContainer}>
          {render(
            preset,
            tips,
            isPreview,
            widgetStep,
            backgroundStyle,
            innerBackgroundStyle
          )}
        </div>
      )}
    </div>
  );
};

export const Template21 = createTemplate(
  styles.template21background,
  styles.template21backgroundInner
);

export const Template22 = createTemplate(
  styles.template22background,
  styles.template22backgroundInner
);

export const Template23 = createTemplate(
  styles.template23background,
  styles.template23backgroundInner
);

export const Template24 = createTemplate(
  styles.template24background,
  styles.template24backgroundInner
);

export const Template25 = createTemplate(
  styles.template25background,
  styles.template25backgroundInner
);
